import { observer } from 'mobx-react-lite'
import { Box, Icon, type ITabItem, Tooltip, Typography } from 'shared/ui'
import { LINK_HOW_DO_MESSAGE_CREDITS_WORK } from 'shared/constants/links'
import { type BillingPeriod, TimePeriodTabs } from 'pages/settings/ui/BillingPlan'
import styles from './styles.module.scss'

const CreditsTooltipContent = () => {
  const creditsInfo = [
    { label: 'SMS:', value: '1 credit (160 characters)' },
    { label: 'MMS:', value: '2 credits (1,600 characters)' },
    { label: 'Calling:', value: '1 credit / min' },
    { label: 'Call forwarding:', value: '2 credits / min' },
  ]

  return (
    <Box display='flex' flexDirection='column' gap={'4px'}>
      <div>
        {creditsInfo.map((item, index) => (
          <Typography
            key={index}
            variant='body-md-regular'
            color='var(--content-primary-primary-inverted)'
            ariaLabel='info_title'
            className={styles.creditsTooltipContentTitle}
          >
            {item.label}
            <Typography
              color='var(--content-primary-tertiary-inverted)'
              ariaLabel='info_value'
              variant='body-md-regular'
            >
              {item.value}
            </Typography>
          </Typography>
        ))}
      </div>

      <a
        href={LINK_HOW_DO_MESSAGE_CREDITS_WORK}
        aria-label={'learn_more_link'}
        target={'_blank'}
        rel='noreferrer'
      >
        Learn more
      </a>
    </Box>
  )
}

type IBillingUpgradeHeaderProps = {
  period: BillingPeriod
  handleSetPeriod: (tab: ITabItem<BillingPeriod>) => void
}

export const UpgradeHeader = observer(({ period, handleSetPeriod }: IBillingUpgradeHeaderProps) => {
  return (
    <>
      <div className={styles.header}>
        <div className={styles.titleInfo}>
          <Typography ariaLabel='upgrade_billing_title' variant='body-xl-medium'>
            Choose your plan
          </Typography>
          <Typography
            ariaLabel='upgrade_billing_description'
            variant='body-md-regular'
            className={styles.description}
          >
            What are credits used for?
            <Tooltip
              label={<CreditsTooltipContent />}
              placement='top'
              padding='8px'
              ariaLabel='credits_info'
            >
              <Icon icon='question' color='var(--content-neutral-primary)' />
            </Tooltip>
          </Typography>
        </div>
        <div className={styles.paymentMethod}>
          <TimePeriodTabs period={period} handleSetPeriod={handleSetPeriod} />
        </div>
      </div>
    </>
  )
})
